import { map, take } from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CultureCodeWithLabel, TranslationRequest, TranslationResult } from './language.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class LabelTranslationService {
  constructor(private http: HttpService) {}

  public getTranslatedStrings(fromCode: string, toCode: string, strings: TranslationRequest[]): Observable<TranslationResult[]> {
    const url = `${apiBaseUrl}/v1/meta/translations/strings`;
    const request = {
      fromCode: fromCode,
      toCodes: [toCode],
      strings: strings
    };
    return this.http.post(url, request);
  }

  public getTranslatedDatasetStrings(fromCode: string, toCode: string, strings: TranslationRequest[]): Observable<TranslationResult[]> {
    const url = `${apiBaseUrl}/v1/meta/translations/strings.dataset`;
    const request = {
      fromCode: fromCode,
      toCodes: [toCode],
      strings: strings
    };
    return this.http.post(url, request);
  }

  public getTranslatedDocumentStrings(fromCode: string, toCode: string, strings: TranslationRequest[]): Observable<TranslationResult[]> {
    const url = `${apiBaseUrl}/v1/meta/translations/strings.document`;
    const request = {
      fromCode: fromCode,
      toCodes: [toCode],
      strings: strings
    };
    return this.http.post(url, request);
  }
}
